export default __webpack_public_path__ + "static/img_welfare_10@2x-f37d5de8626a000c85e8d0807335a03d.jpg";